import Input from './_input';
import vFocus from './v-focus';

Input.vFocus = vFocus;

export default Input;
